import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "addUserInput",
    "inviteLabel",
    "addUserLabel",
    "field"
  ]

  toggle(event) {
    const isAddUser = event.target.checked
    this.addUserInputTarget.value = isAddUser ? "1" : ""
    this.inviteLabelTargets.forEach(el => el.classList.toggle("hidden", isAddUser))
    this.addUserLabelTargets.forEach(el => el.classList.toggle("hidden", !isAddUser))
    this.fieldTargets.forEach(field => { field.disabled = !isAddUser })
  }
}
